import { render, staticRenderFns } from "./staffbox.vue?vue&type=template&id=aa7f3ba2&"
import script from "./staffbox.vue?vue&type=script&lang=js&"
export * from "./staffbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports